import { useContext } from 'react';
import { SessionContext, type SessionValue } from './SessionContext';

export function useSession(): SessionValue {
  const session = useContext(SessionContext);
  if (session === null) {
    throw new Error('useSession se usó fuera de SessionProvider.');
  }

  return session;
}
